<template>
  <section class="relative flex justify-center w-full">
    <div class="w-full min-[1200px]:w-4/5 max-[1199px]:px-5">
      <div class="flex max-sm:flex-col items-center gap-5 w-full mb-10">
        <button
          @click="selectButton('agenda')"
          class="px-6 py-2 border border-white uppercase hover:bg-[#00a375]"
          :class="
            selectedButton === 'agenda' ? 'bg-[#00a375]' : 'bg-transparent'
          "
        >
          {{ lang === "mn" ? "Хөтөлбөр" : "Agenda" }}
        </button>
        <button
          @click="selectButton('sign')"
          class="px-6 py-2 border border-white uppercase hover:bg-[#00a375]"
          :class="selectedButton === 'sign' ? 'bg-[#00a375]' : 'bg-transparent'"
        >
          {{ lang === "mn" ? "Бүртгүүлэх" : "Registration" }}
        </button>
      </div>

      <div v-if="selectedButton === 'agenda'" class="min-h-[10rem]"></div>
      <div v-if="selectedButton === 'sign'">
        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-between gap-x-8 gap-y-5"
        >
          <div class="flex items-center gap-3 max-md:text-sm">
            <label for="company" class="w-1/3 text-end">{{
              lang === "mn" ? "Байгууллага:" : "Company:"
            }}</label>
            <input
              name="company"
              id="company"
              type="text"
              class="w-2/3 border p-2 bg-white text-black"
              :class="
                !form.company && isSubmitted ? 'border-red-500' : 'border-white'
              "
              v-model="form.company"
            />
          </div>
          <div class="flex items-center gap-3">
            <label for="first_name" class="w-1/3 text-end">{{
              lang === "mn" ? "Нэр:" : "First Name:"
            }}</label>
            <input
              name="first_name"
              id="first_name"
              type="text"
              class="w-2/3 border p-2 bg-white text-black"
              :class="
                !form.first_name && isSubmitted
                  ? 'border-red-500'
                  : 'border-white'
              "
              v-model="form.first_name"
            />
          </div>
          <div class="flex items-center gap-3">
            <label for="last_name" class="w-1/3 text-end">{{
              lang === "mn" ? "Овог:" : "Last Name:"
            }}</label>
            <input
              name="last_name"
              id="last_name"
              type="text"
              class="w-2/3 border p-2 bg-white text-black"
              :class="
                !form.last_name && isSubmitted
                  ? 'border-red-500'
                  : 'border-white'
              "
              v-model="form.last_name"
            />
          </div>

          <div class="flex items-center gap-3">
            <label for="country" class="w-1/3 text-end">{{
              lang === "mn" ? "Улс:" : "Country:"
            }}</label>
            <country-select
              :country="form.country"
              topCountry="MN"
              :placeholder="lang === 'mn' ? 'Улс сонгох' : 'Select Country'"
              class="w-2/3 border p-2 bg-white text-black"
              :class="
                !form.country && isSubmitted ? 'border-red-500' : 'border-white'
              "
              v-model="form.country"
            />
          </div>
          <div class="flex items-center gap-3">
            <label for="email" class="w-1/3 text-end">{{
              lang === "mn" ? "И-мэйл:" : "E-mail:"
            }}</label>
            <input
              name="email"
              id="email"
              type="email"
              class="w-2/3 border p-2 bg-white text-black"
              :class="
                !form.email && isSubmitted ? 'border-red-500' : 'border-white'
              "
              v-model="form.email"
            />
          </div>
          <div class="flex items-center gap-3">
            <label for="phone_number" class="w-1/3 text-end">{{
              lang === "mn" ? "Утас:" : "Phone Number:"
            }}</label>
            <input
              name="phone_number"
              id="phone_number"
              type="tel"
              class="w-2/3 border p-2 bg-white text-black"
              :class="
                !form.phone_number && isSubmitted
                  ? 'border-red-500'
                  : 'border-white'
              "
              v-model="form.phone_number"
            />
          </div>
        </div>

        <p class="flex items-center gap-2 text-xs sm:text-sm md:text-base mt-5">
          <font-awesome-icon icon="fa-solid fa-triangle-exclamation" />
          {{
            lang === "mn"
              ? " Арга хэмжээний дэлгэрэнгүй хөтөлбөр гарах үед бид таны бүртгүүлсэн и-мэйл хаягаар хүргүүлэх болно."
              : "When the detailed program of the event is finalized, we will send it to you via the email address you registered with."
          }}
        </p>

        <p
          v-if="isSubmitted && !validateForm()"
          class="text-center text-amber-500 mt-7"
        >
          {{
            lang === "mn"
              ? "Уучлаарай, бүртгэл хэсгийг бүрэн бөглөнө үү."
              : "Sorry, please complete the registration section."
          }}
        </p>

        <div
          class="flex justify-center gap-3"
          :class="validateForm() || !isSubmitted ? 'mt-7' : 'mt-3'"
        >
          <button
            v-if="!success && !isLoading"
            @click="submitForm()"
            class="w-[10rem] p-2 text-center border border-white hover:bg-[#00a375]"
          >
            {{ lang === "mn" ? "Бүртгүүлэх" : "Register" }}
          </button>

          <div
            v-else-if="!success && isLoading"
            class="w-[10rem] p-2 border border-white flex justify-center items-center"
          >
            <SingleSpinLoading />
          </div>

          <div
            v-else-if="success && !isLoading"
            class="relative flex items-center gap-2 bg-white shadow shadow-white p-2 text-black font-bold"
          >
            <font-awesome-icon
              icon="fa-solid fa-check"
              class="text-[#4BB543] text-base"
            />
            {{
              lang === "mn"
                ? "Бүртгэл амжилттай хийгдлээ."
                : "Registration successful."
            }}
            <div class="absolute h-1 bottom-0 bg-[#4BB543] animate-line"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import clientMWInstance from "@/lib/clientMWInstance";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import SingleSpinLoading from "@/components/MiningWeek/SingleSpinLoading";

export default {
  name: "MWForm",
  components: {
    SingleSpinLoading,
  },
  setup() {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    //SIGN FORM
    const selectedButton = ref("agenda");
    const selectButton = (item) => {
      selectedButton.value = item;
    };

    const isLoading = ref(false);
    const success = ref(false);
    const isSubmitted = ref(false);
    const form = ref({
      company: null,
      first_name: null,
      last_name: null,
      country: null,
      email: null,
      phone_number: null,
    });

    const validateForm = () => {
      return (
        form.value.company &&
        form.value.first_name &&
        form.value.last_name &&
        form.value.country &&
        form.value.email &&
        form.value.phone_number
      );
    };

    const resetForm = () => {
      form.value = {
        company: null,
        first_name: null,
        last_name: null,
        country: null,
        email: null,
        phone_number: null,
      };
    };

    const submitForm = async () => {
      isSubmitted.value = true;

      if (!validateForm()) {
        return;
      }

      try {
        isLoading.value = true;
        const res = await clientMWInstance.post(
          "/insert/registration",
          form.value
        );
        if (res.status === 200) {
          isSubmitted.value = false;
          success.value = true;
          resetForm();

          setTimeout(() => {
            success.value = false;
          }, 10000);
        }
      } catch (err) {
        console.error(err);
      } finally {
        isLoading.value = false;
      }
    };

    return {
      lang,
      selectButton,
      selectedButton,
      form,
      isLoading,
      submitForm,
      success,
      isSubmitted,
      validateForm,
    };
  },
};
</script>

<style scoped>
@keyframes lineAnimation {
  from {
    width: 0%;
  }
  to {
    width: 95%;
  }
}

.animate-line {
  animation: lineAnimation 9s linear forwards;
}
</style>
